import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

import { useCurrentSidebarTab } from '.';

type TCurrentBlockStoreState = {
  currentBlock: string | null;
  setCurrentBlock: (v: string | null) => void;
};

const Context = createContext<TCurrentBlockStoreState | null>(null);

type Props = {
  children: React.ReactNode;
};
export function Provider({ children }: Props) {
  const [currentBlock, setCurrentBlock] = useState<string | null>(null);
  const value = useMemo<TCurrentBlockStoreState>(
    () => ({ currentBlock, setCurrentBlock }),
    [currentBlock, setCurrentBlock]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useCurrentBlockId() {
  return useContext(Context)!.currentBlock;
}

export function useSetCurrentBlockId() {
  const [, setCurrentSidebarTab] = useCurrentSidebarTab();
  const setCurrentBlock = useContext(Context)!.setCurrentBlock;
  return useCallback(
    (v: string | null) => {
      setCurrentSidebarTab(v === null ? 'STYLES' : 'INSPECT');
      setCurrentBlock(v);
    },
    [setCurrentSidebarTab, setCurrentBlock]
  );
}
